import TablePagination from '@mui/material/TablePagination';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import memberService from '../../../services/membersService';

import { Racers as RacersStore } from '../../../stores';

type Props = {
  startlistMembersStore: RacersStore;
  distance_id: number;
  switchedOnTop: boolean;
};

const PaginationComponent = ({ startlistMembersStore, distance_id, switchedOnTop }: Props) => {
  const { paginationMeta } = startlistMembersStore;
  const page = startlistMembersStore.page;
  const { per_page, total } = paginationMeta;

  return (
    <TablePagination
      component='div'
      count={total || 0}
      rowsPerPage={per_page || 30}
      page={page - 1}
      className={classnames({ pagination: !switchedOnTop })}
      classes={{
        selectLabel: 'caption',
        displayedRows: 'caption',
        select: 'choose-num',
        selectIcon: 'choose-num-svg',
      }}
      rowsPerPageOptions={[30, 50, 100, 200]}
      backIconButtonProps={{
        'aria-label': 'Previous Page',
      }}
      nextIconButtonProps={{
        'aria-label': 'Next Page',
      }}
      onPageChange={(event, page) => {
        memberService.loadResources(distance_id, {}, page + 1);
      }}
      onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        memberService.loadResources(distance_id, { limit: Number(event.target.value) });
      }}
    />
  );
};

export const Pagination = observer(PaginationComponent);
